// File: frontend/src/components/Pipeline/RealTimeIndicator.jsx
// Real-time updates indicator for the Kanban pipeline

import React, { useState, useEffect } from 'react';
import { BoltIcon, WifiIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const RealTimeIndicator = ({ isOnline, lastUpdate, onRefresh }) => {
  const [timeSinceUpdate, setTimeSinceUpdate] = useState('');

  useEffect(() => {
    const calculateTimeSinceUpdate = () => {
      if (!lastUpdate) return 'Aguardando atualização...';
      
      const now = new Date();
      const update = new Date(lastUpdate);
      const diffInSeconds = Math.floor((now - update) / 1000);
      
      if (diffInSeconds < 60) {
        return `Atualizado há ${diffInSeconds} segundos`;
      }
      
      const diffInMinutes = Math.floor(diffInSeconds / 60);
      if (diffInMinutes < 60) {
        return `Atualizado há ${diffInMinutes} minutos`;
      }
      
      const diffInHours = Math.floor(diffInMinutes / 60);
      return `Atualizado há ${diffInHours} horas`;
    };
    
    setTimeSinceUpdate(calculateTimeSinceUpdate());
    
    const interval = setInterval(() => {
      setTimeSinceUpdate(calculateTimeSinceUpdate());
    }, 30000); // Update every 30 seconds
    
    return () => clearInterval(interval);
  }, [lastUpdate]);

  return (
    <div className="flex items-center space-x-3 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 px-4 py-2">
      <div className="flex items-center">
        {isOnline ? (
          <div className="flex items-center">
            <BoltIcon className="h-5 w-5 text-green-500 animate-pulse" />
            <span className="ml-2 text-sm font-medium text-green-700 dark:text-green-400">
              Tempo Real
            </span>
          </div>
        ) : (
          <div className="flex items-center">
            <ExclamationTriangleIcon className="h-5 w-5 text-red-500" />
            <span className="ml-2 text-sm font-medium text-red-700 dark:text-red-400">
              Offline
            </span>
          </div>
        )}
      </div>
      
      <div className="text-sm text-gray-500 dark:text-gray-400">
        {timeSinceUpdate}
      </div>
      
      <button
        onClick={onRefresh}
        className="text-sm text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
      >
        Atualizar
      </button>
    </div>
  );
};

export default RealTimeIndicator;